"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const cootsMaxVelocity_1 = __importDefault(require("../../constants/cootsMaxVelocity"));
const walkingThreshold_1 = __importDefault(require("../../constants/walkingThreshold"));
const state_1 = __importDefault(require("../../state"));
const getLaserPower_1 = __importDefault(require("../getLaserPower"));
const getMouseCoords_1 = __importDefault(require("../getMouseCoords"));
const isCootsInObstacle_1 = __importDefault(require("../isCootsInObstacle"));
const updateCootsVelocity = () => {
    if (state_1.default.hasMouseScreenCoords()) {
        const mouseCoords = (0, getMouseCoords_1.default)();
        const diffX = mouseCoords.x - state_1.default.cootsCoords.x;
        const diffY = mouseCoords.y - state_1.default.cootsCoords.y;
        const angle = Math.atan2(diffY, diffX);
        const xVector = Math.cos(angle);
        const yVector = Math.sin(angle);
        // Increase velocity based on laser pointer
        if ((0, isCootsInObstacle_1.default)() === false) {
            const laserPower = (0, getLaserPower_1.default)();
            if (laserPower >= walkingThreshold_1.default) {
                const accelerationFactor = 1.5;
                const multiplier = (cootsMaxVelocity_1.default
                    * (state_1.default.app.ticker.deltaMS / 1000)
                    * accelerationFactor
                    * laserPower);
                state_1.default.cootsVelocityX += xVector * multiplier;
                state_1.default.cootsVelocityY += yVector * multiplier;
            }
        }
        // Decay
        state_1.default.cootsVelocityX -= state_1.default.cootsVelocityX * .5 * (state_1.default.app.ticker.deltaMS / 1000);
        state_1.default.cootsVelocityY -= state_1.default.cootsVelocityY * .5 * (state_1.default.app.ticker.deltaMS / 1000);
        // Cap velocity at max
        if (state_1.default.cootsVelocityX > cootsMaxVelocity_1.default) {
            state_1.default.cootsVelocityX = cootsMaxVelocity_1.default;
        }
        if (state_1.default.cootsVelocityX < -cootsMaxVelocity_1.default) {
            state_1.default.cootsVelocityX = -cootsMaxVelocity_1.default;
        }
        if (state_1.default.cootsVelocityY > cootsMaxVelocity_1.default) {
            state_1.default.cootsVelocityY = cootsMaxVelocity_1.default;
        }
        if (state_1.default.cootsVelocityY < -cootsMaxVelocity_1.default) {
            state_1.default.cootsVelocityY = -cootsMaxVelocity_1.default;
        }
    }
};
exports.default = updateCootsVelocity;
